<template>
  <WidgetKpiCard
    :error="!!error"
    :loading="loading"
    :lastUpdate="lastUpdate"
    @click:refresh="refresh"
    @click:table="showTable"
  >
    <template #title>
      {{ $t("widgets.rate.title") }}
    </template>

    <template v-if="data" #main>
      <KpiMain
        :value="data.main.value"
        :format="v => v.toPrecision(2)"
        :title="dateNames.year"
      ></KpiMain>
    </template>

    <template v-if="data" #subs>
      <KpiSub
        :title="dateNames.month"
        :value="data.subs.month.value"
        :format="v => v.toPrecision(2)"
      ></KpiSub>
      <KpiSub
        :title="$t('widgets.rate.negativeRating')"
        :value="data.subs.ranking.poor.value"
        :format="v => v.toPrecision(2) + ' 🙁'"
      ></KpiSub>
      <KpiSub
        :title="$t('widgets.rate.neutralRating')"
        :value="data.subs.ranking.average.value"
        :format="v => v.toPrecision(2) + ' 😐'"
      ></KpiSub>
      <KpiSub
        :title="$t('widgets.rate.positiveRating')"
        :value="data.subs.ranking.good.value"
        :format="v => v.toPrecision(2) + ' 😊'"
      ></KpiSub>
    </template>
  </WidgetKpiCard>
</template>
<script>
import WidgetKpiCard from "./WidgetKpiCard.vue";
import KpiSub from "./WidgetKpiCard/KpiSub.vue";
import KpiMain from "./WidgetKpiCard/KpiMain.vue";

import { usePeriodNames } from "@/composables/date";
import { useWidgetApi } from "@/composables/api/widget";
import { useRouter } from "@/composables/router";

export default {
  components: { WidgetKpiCard, KpiSub, KpiMain },

  props: {
    hover: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    const { data, lastUpdate, loading, error, execute } =
      useWidgetApi("/dashboard/rate");

    const router = useRouter();

    const showTable = () => {
      router.push({
        name: "DashboardTable",
        query: { measure: "rate" }
      });
    };

    const dateNames = usePeriodNames();

    return {
      data,
      error,
      loading,
      lastUpdate,
      dateNames,

      refresh: execute,
      showTable
    };
  }
};
</script>
<style></style>
